import { AuthGuard, bomUpdateAuthScope, CrudOp } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const UpdateMonitorView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  const bomDataSource = useRequiredProjectParam("bomDataSource");
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  return (
    <AuthGuard authScope={bomUpdateAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyUpdateMonitorView brand={brand} bomDataSource={bomDataSource} projectId={projectId} subprojectId={subprojectId}/></Suspense>
    </AuthGuard>
  );
};

const LazyUpdateMonitorView = lazy(importView(
  () => import("../components/UpdateMonitorView"),
  (it) => it.UpdateMonitorView,
));
